import { render } from "./AdminMenuComponent.vue?vue&type=template&id=ef777c6c&scoped=true"
import script from "./AdminMenuComponent.vue?vue&type=script&lang=js"
export * from "./AdminMenuComponent.vue?vue&type=script&lang=js"

import "./AdminMenuComponent.vue?vue&type=style&index=0&id=ef777c6c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef777c6c"]])

export default __exports__